var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77179 1.27992C9.11836 1.27992 10.4247 1.53483 11.64 2.02603L10.714 3.06749C9.77654 2.74902 8.78799 2.58144 7.77126 2.58144C5.28866 2.58144 2.96003 3.57089 1.20479 5.35854C0.954517 5.61346 0.546017 5.61346 0.29574 5.35854C0.045463 5.10363 0.045463 4.68757 0.29574 4.43266C2.29547 2.40181 4.94817 1.2793 7.77113 1.2793L7.77179 1.27992Z",
    fill: "#CD0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2539 5.35897C15.129 5.4861 14.9639 5.54968 14.7993 5.54968C14.6348 5.54968 14.4696 5.48611 14.3448 5.35897C13.9527 4.95959 13.5265 4.59553 13.084 4.28283L13.9477 3.30493C14.4079 3.64075 14.8454 4.01636 15.2539 4.43308C15.5042 4.68799 15.5041 5.10406 15.2539 5.35897Z",
    fill: "#CD0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52204 4.41578L8.50518 5.55549C6.62471 5.33526 4.67098 5.96064 3.23368 7.42394C2.9834 7.67885 2.58056 7.67885 2.33029 7.42394C2.08001 7.16902 2.08001 6.75873 2.33029 6.50382C4.27886 4.51916 7.01677 3.81925 9.52196 4.41511L9.52204 4.41578Z",
    fill: "#CD0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.22 7.42438C13.0951 7.55152 12.93 7.61509 12.7711 7.61509C12.6066 7.61509 12.4414 7.55152 12.3166 7.42438C11.9528 7.0539 11.5557 6.73606 11.1295 6.47538L12.0045 5.4917C12.4364 5.78128 12.8398 6.11645 13.22 6.50428C13.4702 6.75919 13.4702 7.16947 13.22 7.42438Z",
    fill: "#CD0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35827 8.57008C5.10216 7.81241 6.03959 7.33791 7.05648 7.18188L4.84114 9.67577C4.67092 9.68733 4.48874 9.62376 4.35824 9.49021C4.10796 9.2353 4.10799 8.82499 4.35827 8.57008Z",
    fill: "#CD0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1918 9.49021C11.067 9.61734 10.9018 9.68092 10.7373 9.68092C10.5784 9.68092 10.4133 9.61735 10.2885 9.49021C9.95938 9.15503 9.56726 8.88857 9.14679 8.70943L10.0445 7.70264C10.465 7.92801 10.8508 8.22338 11.1919 8.57073C11.4421 8.82564 11.4421 9.23594 11.1919 9.49085L11.1918 9.49021Z",
    fill: "#CD0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30016 11.735C9.30016 12.5916 8.61867 13.2857 7.77203 13.2857C7.00481 13.2857 6.36873 12.7072 6.2666 11.9553L7.84011 10.1792C8.65776 10.2197 9.30016 10.8964 9.30016 11.7356V11.735Z",
    fill: "#CD0000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12464 14.0562C3.00739 14.0523 2.89139 14.008 2.79746 13.922C2.58816 13.7294 2.57178 13.4 2.76153 13.1868L13.9746 0.559543C14.1631 0.345725 14.4871 0.329041 14.6964 0.522943C14.9057 0.715574 14.9221 1.04496 14.7324 1.25814L3.51978 13.8847C3.41513 14.0029 3.2695 14.0607 3.12451 14.0555L3.12464 14.0562Z",
    fill: "#CD0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.3dbc6b1f452264fb0c584db2f01b6d50.svg";
export { ForwardRef as ReactComponent };